import { useMutationWithErrorHandling, usePost } from '@app/sdk';

export function useAssociateAccount() {
  const post = usePost(true, "cus");

  function associateAccount(customerId: string, accountId: string): Promise<CustomerSearchResult[]> {
    return post<CustomerSearchResult[]>(
      `/api/proxy/cus/customer-information-service/customers/${customerId}/account-association`,
      {
        accountId,
        externalId: `${customerId}-link`,
      }
    );
  }

  return useMutationWithErrorHandling({
    mutationFn: async (data: { customerId: string; accountId: string }) =>
      await associateAccount(data.customerId, data.accountId),
  });
}
